import jquery from "./jquery-3.7.0";
export default (window.$ = window.jQuery = jquery);